module.exports = __webpack_public_path__ + "static/media/calendar-checked.e16ccf8b.svg";